<div class="p-fluid p-grid">
  <div class="order-form-container">
    <form novalidate #formRef2="ngForm" (ngSubmit)="onSubmit(formRef2)">
      <div class="border-panel">
        <p class="centered-border1">Existing Address</p>
        <div style="display: flex; flex-direction: column;">
          <div style="display: flex; padding-left: 2% ">

            <div
              style="display: flex;flex-direction: column;padding-right: 45px; border-right: 2px solid inherit;">

              <div class="orderentryaddressdiv" style="margin-bottom: 10px;">
                <div class="col-sm-5 form-group">
                  <label class="font-label-text required-label">House Number: *</label>
                  <app-textinput [(ngModel)]="newHouseNumber" name="newHouseNumber"
                    (valueChange)="onNewHouseNoChange($event)" [maxlength]="10" [required]="true"
                  [placeholder]="'House Number'" #newHouseNoRef="ngModel"></app-textinput>
                  @if (newHouseNoRef.invalid && newHouseNoRef.touched) {
                    <div
                      class="text-danger Validation">
                      Enter House Number.
                    </div>
                  }
                </div>
                <div class="col-sm-5 form-group">
                  <label class="font-label-text required-label">Street: *</label>
                  <app-textinput [(ngModel)]="newStreet" name="newStreet"
                    (valueChange)="onNewStreetChange($event)" [required]="true"
                    [placeholder]="'Street'" #newStreetRef="ngModel"
                  [maxlength]="20"></app-textinput>
                  @if (newStreetRef.invalid && newStreetRef.touched) {
                    <div
                      class="text-danger Validation">
                      Enter Street Address.
                    </div>
                  }
                </div>
              </div>

              <div class="orderentryaddressdiv" style="margin-bottom: 10px;">
                @if (isNewCityText) {
                  <div class="col-sm-4 form-group">
                    <label class="font-label-text required-label">City: *</label>
                    <app-textinput [(ngModel)]="newCityValue" name="newCityValue"
                      (valueChange)="onNewCityTextChange($event)" [required]="true"
                    [placeholder]="'City'" #newCityRef="ngModel"></app-textinput>
                    @if (newCityRef.invalid && newCityRef.touched) {
                      <div
                        class="text-danger Validation">
                        Enter City Name.
                      </div>
                    }
                  </div>
                }
                @if (!isNewCityText) {
                  <div class="col-sm-5 form-group" [ngClass]="{'disabled-class': isNewCity}"
                    >
                    <label class="font-label-text required-label">City: *</label>
                    <app-dropdown [options]="CityDropdownOptions" [(selectedValue)]="newCityValue"
                      (selectedValueChange)="OnNewCityChanged($event)" placeholder=""
                      class="custom-width font-label-text fixed-width-dropdown" [showLabel]="true"
                      [showFloatingLabel]="false" [required]="true" [validationName]="'City'"
                    [isFormSubmitted]="isFormSubmitted" class="custom-width"></app-dropdown>
                  </div>
                }
                <div class="col-sm-3 form-group dropdown-container">
                  <label class="font-label-text required-label">State: *</label>
                  <app-dropdown [options]="StateDropdownOptions"
                    [(selectedValue)]="newStateSelectedValue"
                    (selectedValueChange)="OnNewStateChanged($event)" placeholder=""
                    class="fixed-width-dropdown custom-width" [showLabel]="true"
                    [showFloatingLabel]="false" [validationName]="'State'"
                  [isFormSubmitted]="isFormSubmitted" [required]="true"></app-dropdown>
                </div>
                <div class="col-sm-3 form-group" style="width: 27%;">
                  <label class="font-label-text">ZIP:</label>
                  <app-textinput [(ngModel)]="newZip" name="newZip"
                    (valueChange)="onNewZipChange($event)" maxlength="10" [placeholder]="'Zip'"
                  #newZipRef="ngModel"></app-textinput>
                </div>
              </div>
              <hr style="width: 110%;">
              <div style="margin-top: 4px;margin-bottom: 10px;float:right;width: 110%;">
                <div class="col-sm-12 form-group">
                  <div class="meternumdiv">
                    <label class="font-label-text">Meter Number:</label>
                    <div class="col-sm-6">
                      <app-textinput [(ngModel)]="meterNumber" name="meterNumber"
                        (valueChange)="onMeterNumberChange($event)" [maxlength]="15"
                        [placeholder]="'Meter Number'" #meterNumberRef="ngModel"
                      class="newaddresstxtinput"></app-textinput>
                    </div>
                  </div>
                </div>
                                <div class="col-sm-12 form-group" style="display: flex; justify-content: space-between;
                align-items: center;
                width: 100%;padding-bottom: 10px">
                  <label class="font-label-text">Installation Number:</label>
                  <div class="col-sm-6">
                    <app-textinput [(ngModel)]="installationNumber" name="installationNumber"
                      (valueChange)="onInstallationNumberChange($event)" [maxlength]="15"
                      [placeholder]="'Installation Number'" #installationNumberRef="ngModel"
                    class="newaddresstxtinput"></app-textinput>
                  </div>
                </div>




              </div>
            </div>



            <div class="col-sm-4 form-group"
              style="display: flex; flex-direction: column; padding-left: 3px; margin-left: 10px; border-left: 2px solid rgba(75, 85, 99, 0.10)">
              <div class="form-group">
                <label class="font-label-text required-label">Requested Disconnect Date: *</label>


                <p-datepicker [(ngModel)]="disconnectDate" name="disconnectDate" class="calender-icon"
                  [required]="true" [showIcon]="true" (onSelect)="onReqDisconnectDateChange($event)"
                dateFormat="mm/dd/yy" #disconnectDateInput="ngModel"></p-datepicker>
                @if (disconnectDateInput.invalid && disconnectDateInput.touched) {
                  <div
                    class="text-danger Validation">
                    Select service begin date.
                  </div>
                }


              </div>

            </div>



          </div>


        </div>
      </div>









    </form>
  </div>
</div>